var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.267 14.724c0-.725-.069-1.473-.183-2.175h-9.881v4.14h5.66a4.887 4.887 0 0 1-2.1 3.25l3.377 2.689c1.986-1.894 3.127-4.654 3.127-7.904z",
    fill: "#4280EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.203 25.2c2.83 0 5.203-.959 6.937-2.596l-3.377-2.665c-.936.654-2.146 1.029-3.56 1.029-2.739 0-5.044-1.895-5.888-4.42l-3.47 2.736c1.78 3.624 5.387 5.916 9.358 5.916z",
    fill: "#34A353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.315 16.525a6.673 6.673 0 0 1 0-4.116l-3.47-2.76a10.985 10.985 0 0 0 0 9.635l3.47-2.76z",
    fill: "#F6B704"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.203 7.99a5.64 5.64 0 0 1 4.016 1.613l2.99-3.087a9.948 9.948 0 0 0-7.006-2.782c-3.971 0-7.577 2.291-9.357 5.916l3.469 2.76c.844-2.55 3.149-4.42 5.888-4.42z",
    fill: "#E54335"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h28v28H0z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.3dee55edd35ab09984f620d9a7770d82.svg";
export { ForwardRef as ReactComponent };